<template>
  <div class="ml-0 mr-0 w-100">
    <base-header class="pb-2 content__title content__title--calendar">
      <b-row align-v="center" class="pb-0">
        <b-col class="m-0" cols="8">
          <h4
            v-if="false"
            style="color: gray; font-weight: 500; margin-bottom: -5px"
          >
            Período
          </h4>
          <span class="font-weight-normal text-primary">
            <a
              :readonly="isLoading"
              href="#"
              @click.prevent="prev"
              class="fullcalendar-btn-prev btn btn-sm btn-text py-1 vertical-middle mx-0"
            >
              <i
                class="no no-left-arrow font-size-lg text-primary vertical-middle"
              ></i>
            </a>

            <span
              class="booking-list-period-label font-weight-normal text-primary vertical-middle"
            >
              <span @click="openStartDatePicker">
                {{ periodStartDateLabel }}
              </span>
              <span> - </span>
              <span @click="openEndDatePicker">
                {{ periodEndDateLabel }}
              </span>
            </span>

            <date-picker
              ref="startDatePicker"
              v-model="localStartDate"
              @change="onStartDateChange"
              type="date"
              format="dd/MM/yy"
              value-format="yyyy-MM-dd"
              :clearable="false"
              class="booking-list-hidden-datepicker"
            />

            <date-picker
              ref="endDatePicker"
              v-model="localEndDate"
              @change="onEndDateChange"
              type="date"
              format="dd/MM/yy"
              value-format="yyyy-MM-dd"
              :clearable="false"
              class="booking-list-hidden-datepicker"
            />

            <a
              :readonly="isLoading"
              href="#"
              @click.prevent="next"
              class="fullcalendar-btn-next btn btn-sm btn-text py-1 vertical-middle mx-0"
            >
              <i
                class="no no-right-arrow font-size-lg text-primary vertical-middle"
              ></i>
            </a>
          </span>
        </b-col>

        <b-col cols="4" class="m-0 text-right pl-0">
          <div
            v-if="!isMobileView"
            class="d-flex align-items-center justify-content-end w-100"
          >
            <div class="bg-pick">
              <button
                class="btn btn-letter"
                :class="{ active: defaultView === 'timeGridDay' }"
                @click="changeView('timeGridDay')"
              >
                Dia
              </button>
              <button
                class="btn btn-letter"
                :class="{ active: defaultView === 'dayGridWeek' }"
                @click="changeView('dayGridWeek')"
              >
                Semana
              </button>
              <button
                class="btn btn-letter"
                :class="{ active: defaultView === 'dayGridMonth' }"
                @click="changeView('dayGridMonth')"
              >
                Mês
              </button>
            </div>
            <div
              v-if="hasBookingListPermission"
              class="d-flex align-items-center"
            >
              <i
                class="fas fa-th-list pl-4"
                style="cursor: pointer; font-size: 1.5rem; color: #12576e"
                title="Lista de reservas"
                @click.prevent="$router.push('/operation/booking-list')"
              ></i>
            </div>
          </div>
          <div
            v-else
            class="d-flex align-items-center justify-content-end w-100"
          >
            <b-form-select
              :value="defaultView"
              :options="viewModeOptions"
              class="booking-list-view-select"
              @change="changeView"
            />
            <div
              v-if="hasBookingListPermission"
              class="d-flex align-items-center"
            >
              <i
                class="fas fa-th-list pl-4"
                style="cursor: pointer; font-size: 1.5rem; color: #12576e"
                title="Lista de reservas"
                @click.prevent="$router.push('/operation/booking-list')"
              ></i>
            </div>
          </div>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid>
      <b-row>
        <b-col>
          <div class="card-calendar">
            <div class="card-calendar-body d-flex align-items-center">
              <label class="mb-2 d-flex align-items-center show-quotes-toggle">
                <input
                  type="checkbox"
                  :checked="showUnpaid"
                  @change="onShowUnpaidChange"
                />
                <h4 class="mb-0 ml-2">exibir cotações</h4>
              </label>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card-calendar">
            <div style="margin-bottom: 70px" class="p-0 card-calendar-body">
              <full-calendar
                :events="eventsCalendar"
                :plugins="calendarPlugins"
                contentHeight="auto"
                :selectable="false"
                :selectHelper="true"
                ref="fullCalendar"
                class="calendar"
                :defaultView="defaultView"
                @dateClick="onDateClick"
                @eventClick="onDateClick"
                :dayRender="createAlertOnCalendar"
                :eventRender="renderEventTitle"
                :locale="'pt-br'"
                :timeZone="'local'"
                :noEventsText="'Sem operações registradas.'"
                :allDayText="'Dia Inteiro'"
                :handleWindowResize="true"
                :nowIndicator="true"
                :now="new Date()"
                :listDaySideFormat="{
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                }"
                :titleFormat="{ year: 'numeric', month: 'long' }"
                :header="{ start: '', center: '', end: 'title' }"
                :dayMaxEventRows="true"
                :eventLimit="true"
                :eventLimitText="''"
                :views="{ month: { eventLimit: 3 } }"
              >
              </full-calendar>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <reserva-detalhe-sidebar
      v-if="showDateClickedPanel"
      :showDateClickedPanel="showDateClickedPanel"
      @emitNextDayPanel="nextDayPanel"
      @emitPrevDayPanel="prevDayPanel"
      @closePanel="closeDateClickedModal"
    >
    </reserva-detalhe-sidebar>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import ReservaDetalheSidebar from './ReservaDetalheSidebar'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { DatePicker } from 'element-ui'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { computed } from 'vue'
import { isMobile } from '../../store/utils/general'
import { hasRole } from '../../store/utils/users'

export default {
  name: 'CalendarOperacao',

  components: {
    Modal,
    FullCalendar,
    ReservaDetalheSidebar,
    DatePicker,
  },

  props: {
    eventsCalendar: {
      type: Array,
      default: [],
    },

    formDate: {
      type: Object,
      default: {},
    },

    showUnpaid: {
      type: Boolean,
      default: false,
    },
  },

  provide() {
    return {
      selectedDate: computed(() => this.clickedDate['selectedDate']),
      bookings: computed(() => {
        const groups = this.clickedDate
        if (!Array.isArray(groups)) return []
        return groups.reduce((all, group) => {
          return Array.isArray(group) ? all.concat(group) : all
        }, [])
      }),
    }
  },

  inject: ['isLoading'],

  data() {
    return {
      calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      defaultView: 'dayGridMonth',
      isMobileView: isMobile(),
      viewModeOptions: [
        { value: 'timeGridDay', text: 'Dia' },
        { value: 'dayGridWeek', text: 'Semana' },
        { value: 'dayGridMonth', text: 'Mês' },
      ],
      showDateClickedPanel: false,
      clickedDate: [],
      localStartDate: null,
      localEndDate: null,
      fieldsTableEvents: [
        { key: 'code', label: 'ID', sortable: true },
        { key: 'start', label: 'Data', sortable: true },
        { key: 'visitor', label: 'Visitante', sortable: true },
        { key: 'groupSize', label: 'Grupo', sortable: true },
        { key: 'valor', label: 'Valor', sortable: true },
        { key: 'statusText', label: 'Status', sortable: true },
        { key: 'details', label: 'Detalhes', sortable: false },
      ],
      showDetail: false,
      selectedReserva: {},
    }
  },

  computed: {
    ...mapGetters('operacao', {
      isLoading: 'getIsLoading',
    }),

    ...mapGetters('product', {
      poisList: 'getPois',
    }),
    ...mapGetters('auth', {
      roles: 'getRules',
    }),

    hasBookingListPermission() {
      return hasRole('operation', 'booking-list', this.roles)
    },

    ...mapGetters('report', {
      reportBookings: 'getBookings',
    }),

    periodStartDateLabel() {
      if (!this.localStartDate) return '--'
      const start = moment(this.localStartDate)
      if (!start.isValid()) return '--'
      return start.format('DD/MM/YY')
    },

    periodEndDateLabel() {
      if (!this.localEndDate) return '--'
      const end = moment(this.localEndDate)
      if (!end.isValid()) return '--'
      return end.format('DD/MM/YY')
    },

    period() {
      if (this.defaultView == 'dayGridMonth') {
        return `${
          moment(this.formDate.startDate).format('MMMM') +
          ' de ' +
          moment(this.formDate.startDate).format('YYYY')
        }`
      } else if (this.defaultView == 'dayGridWeek') {
        return `${
          moment(this.formDate.startDate).startOf('week').format('DD/MM/YYYY') +
          ' a ' +
          moment(this.formDate.startDate).endOf('week').format('DD/MM/YYYY')
        }`
      } else if (this.defaultView == 'timeGridDay') {
        return moment(this.formDate.startDate).format('DD/MM/YYYY')
      }
    },
  },

  watch: {
    formDate: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!value) return
        this.localStartDate = value.startDate
        this.localEndDate = value.endDate
      },
    },

    eventsCalendar() {
      this.scheduleDayTotals()
    },

    reportBookings() {
      this.scheduleDayTotals()
    },

    defaultView(newValue, oldValue) {
      var formattedToday = moment().format('YYYY-MM-DD')
      var today = moment(formattedToday)

      if (newValue != undefined && newValue.length > 0) {
        var dates = { startDate: today, endDate: today, viewType: newValue }
        const isCurrentMonth = moment(today).isSame(
          this.formDate.startDate,
          'month'
        )
        const isCurrentWeek = moment(today).isSame(
          this.formDate.startDate,
          'week'
        )
        const isCurrentDay = moment().isSame(this.formDate.startDate, 'day')

        // MONTH TO WEEK
        if (oldValue == 'dayGridMonth' && newValue == 'dayGridWeek') {
          if (isCurrentMonth) {
            dates.startDate = moment().startOf('week').format('YYYY-MM-DD')
            dates.endDate = moment().endOf('week').format('YYYY-MM-DD')
          } else {
            dates.startDate = moment(this.formDate.startDate)
              .startOf('month')
              .format('YYYY-MM-DD')
            dates.endDate = moment(this.formDate.startDate)
              .endOf('week')
              .format('YYYY-MM-DD')
          }
        }

        // MONTH TO DAY
        if (oldValue == 'dayGridMonth' && newValue == 'timeGridDay') {
          if (isCurrentMonth) {
            dates.startDate = moment(today).format('YYYY-MM-DD')
            dates.endDate = moment(today).format('YYYY-MM-DD')
          } else {
            dates.startDate = moment(this.formDate.startDate)
              .startOf('month')
              .format('YYYY-MM-DD')
            dates.endDate = moment(this.formDate.startDate)
              .startOf('month')
              .format('YYYY-MM-DD')
          }
        }

        // DAY TO MONTH
        if (oldValue == 'timeGridDay' && newValue == 'dayGridMonth') {
          if (isCurrentDay) {
            dates.startDate = moment().startOf('month').format('YYYY-MM-DD')
            dates.endDate = moment().endOf('month').format('YYYY-MM-DD')
          } else {
            dates.startDate = moment(this.formDate.startDate)
              .startOf('month')
              .format('YYYY-MM-DD')
            dates.endDate = moment(this.formDate.endDate)
              .endOf('month')
              .format('YYYY-MM-DD')
          }
        }

        // DAY TO WEEK
        if (oldValue == 'timeGridDay' && newValue == 'dayGridWeek') {
          if (isCurrentWeek) {
            dates.startDate = moment().startOf('week').format('YYYY-MM-DD')
            dates.endDate = moment().endOf('week').format('YYYY-MM-DD')
          } else {
            dates.startDate = moment(this.formDate.startDate)
              .startOf('week')
              .format('YYYY-MM-DD')
            dates.endDate = moment(this.formDate.startDate)
              .endOf('week')
              .format('YYYY-MM-DD')
          }
        }

        // WEEK TO MONTH
        if (oldValue == 'dayGridWeek' && newValue == 'dayGridMonth') {
          if (isCurrentWeek) {
            dates.startDate = moment().startOf('month').format('YYYY-MM-DD')
            dates.endDate = moment().endOf('month').format('YYYY-MM-DD')
          } else {
            dates.startDate = moment(this.formDate.startDate)
              .startOf('month')
              .format('YYYY-MM-DD')
            dates.endDate = moment(this.formDate.startDate)
              .endOf('month')
              .format('YYYY-MM-DD')
          }
        }

        // WEEK TO DAY
        if (oldValue == 'dayGridWeek' && newValue == 'timeGridDay') {
          if (isCurrentWeek) {
            dates.startDate = moment().format('YYYY-MM-DD')
            dates.endDate = moment().format('YYYY-MM-DD')
          } else {
            dates.startDate = moment(this.formDate.startDate).format(
              'YYYY-MM-DD'
            )
            dates.endDate = moment(this.formDate.endDate).format('YYYY-MM-DD')
          }
        }

        this.$emit('calendarDateChanged', dates)
        sessionStorage.setItem('operationViewMode', newValue)
      }
    },
  },

  methods: {
    onShowUnpaidChange(event) {
      this.$emit('showUnpaidChanged', event.target.checked)
    },

    openStartDatePicker() {
      const picker = this.$refs.startDatePicker
      if (!picker) return
      if (typeof picker.focus === 'function') {
        picker.focus()
      }
      picker.pickerVisible = true
    },

    openEndDatePicker() {
      const picker = this.$refs.endDatePicker
      if (!picker) return
      if (typeof picker.focus === 'function') {
        picker.focus()
      }
      picker.pickerVisible = true
    },

    emitPeriodChange() {
      this.$emit('calendarDateChanged', {
        startDate: this.localStartDate,
        endDate: this.localEndDate,
        viewType: this.defaultView,
      })
    },

    periodShiftUnit() {
      if (this.defaultView === 'dayGridWeek') return 'week'
      if (this.defaultView === 'dayGridMonth') return 'month'
      return null
    },

    syncPairedPeriodDate(changed) {
      const start = moment(this.localStartDate)
      const end = moment(this.localEndDate)
      if (changed === 'start' && !start.isValid()) return
      if (changed === 'end' && !end.isValid()) return

      const unit = this.periodShiftUnit()
      if (!unit) {
        const same =
          changed === 'start'
            ? start.format('YYYY-MM-DD')
            : end.format('YYYY-MM-DD')
        this.localStartDate = same
        this.localEndDate = same
        return
      }

      if (changed === 'start') {
        this.localEndDate = start.clone().add(1, unit).format('YYYY-MM-DD')
        return
      }

      this.localStartDate = end.clone().subtract(1, unit).format('YYYY-MM-DD')
    },

    closePeriodPickers() {
      ;['startDatePicker', 'endDatePicker'].forEach((ref) => {
        const picker = this.$refs[ref]
        if (picker) picker.pickerVisible = false
      })
    },

    onStartDateChange(value) {
      if (!value) return
      this.syncPairedPeriodDate('start')
      this.closePeriodPickers()
      this.emitPeriodChange()
      if (this.$refs.fullCalendar) {
        this.calendarApi().gotoDate(this.localStartDate)
      }
    },

    onEndDateChange(value) {
      if (!value) return
      this.syncPairedPeriodDate('end')
      this.closePeriodPickers()
      this.emitPeriodChange()
    },

    setPeriod() {
      if (this.defaultView == 'dayGridMonth') {
        return `${
          moment(this.formDate.startDate).format('MMMM') +
          ' de ' +
          moment(this.formDate.startDate).format('YYYY')
        }`
      } else if (this.defaultView == 'dayGridWeek') {
        return `${
          moment(this.formDate.startDate).startOf('week').format('DD/MM/YYYY') +
          ' a ' +
          moment(this.formDate.startDate).endOf('week').format('DD/MM/YYYY')
        }`
      } else if (this.defaultView == 'timeGridDay') {
        return moment(this.formDate.startDate).format('DD/MM/YYYY')
      }
    },

    createAlertOnCalendar(dayRenderInfo) {
      if (dayRenderInfo.date && this.poisList.length > 0) {
        const dateHasBlocks = this.poisList
          .flatMap((i) => Object.keys(i.unavailability))
          .some((i) => i == moment(dayRenderInfo.date).format('YYYY-MM-DD'))
          ? true
          : false

        if (dateHasBlocks) {
          dayRenderInfo.el.innerHTML = `<span>
            <i class="no no-c-warning no-md pl-1 pt-1" style="color: #D93051;"></i>
          </span>`
        }

        return dayRenderInfo
      }
    },

    renderEventTitle(info) {
      const titleEl =
        info.el &&
        (info.el.querySelector('.fc-title') ||
          info.el.querySelector('.fc-event-title'))

      if (titleEl && info.event && info.event.title) {
        titleEl.innerHTML = info.event.title
        titleEl.style.whiteSpace = 'nowrap'
        titleEl.style.overflow = 'hidden'
        titleEl.style.textOverflow = 'ellipsis'
      }

      const eventLabel =
        info.event &&
        info.event.extendedProps &&
        info.event.extendedProps.eventLabel
      if (info.el && eventLabel) {
        info.el.setAttribute('title', eventLabel)
      }

      const borderColor =
        (info.event && info.event.borderColor) ||
        (info.event &&
          info.event.extendedProps &&
          info.event.extendedProps.borderColor) ||
        (info.event &&
          info.event.extendedProps &&
          info.event.extendedProps.statusColor)

      if (info.el && borderColor) {
        info.el.style.borderLeftColor = borderColor
      }
      // não retornar valor: no FullCalendar v4, qualquer retorno !== true
      // substitui o elemento DOM do evento e ele deixa de aparecer
      this.scheduleDayTotals()
    },

    // O "+N" do mês é o que não coube na célula (limite de 3 linhas, uma delas
    // o link). O relatório conta todas as reservas do dia e as pessoas confirmadas.
    dayBookingTotals(dateKey) {
      const bookings = (this.reportBookings || []).filter(
        (booking) => String(booking.data || '').slice(0, 10) === dateKey
      )
      const people = bookings.reduce((sum, booking) => {
        if (String(booking.status || '').toUpperCase() !== 'APPROVED') return sum
        const count =
          booking.people &&
          booking.people.tableText &&
          booking.people.tableText.count
        return sum + (Number(count) || 0)
      }, 0)
      return { bookings: bookings.length, people }
    },

    scheduleDayTotals() {
      clearTimeout(this.dayTotalsTimer)
      this.dayTotalsTimer = setTimeout(() => this.paintDayTotals(), 30)
    },

    paintDayTotals() {
      const root = this.$el
      if (!root) return
      root.querySelectorAll('.fc-day-grid .fc-row.fc-week').forEach((week) => {
        const days = [...week.querySelectorAll('.fc-bg td.fc-day[data-date]')].map(
          (cell) => {
            const box = cell.getBoundingClientRect()
            return {
              date: cell.getAttribute('data-date'),
              left: box.left,
              right: box.right,
            }
          }
        )
        week.querySelectorAll('a.fc-more').forEach((link) => {
          const box = link.getBoundingClientRect()
          if (box.width < 2) return
          const mid = (box.left + box.right) / 2
          const day = days.find(
            (item) => mid >= item.left - 1 && mid <= item.right + 1
          )
          if (!day) return
          const totals = this.dayBookingTotals(day.date)
          link.classList.add('bc-day-totals')
          link.innerHTML =
            `<i class="fas fa-ticket-alt"></i> ${totals.bookings}` +
            `<span class="bc-day-totals-sep">-</span>` +
            `<i class="fas fa-user-alt"></i> ${totals.people}`
          link.setAttribute(
            'title',
            `${totals.bookings} reservas e ${totals.people} pessoas`
          )
        })
      })
    },

    calendarApi() {
      return this.$refs.fullCalendar.getApi()
    },

    changeView(viewType) {
      this.defaultView = viewType
      var dates = {
        startDate: moment(this.formDate.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.formDate.endDate).format('YYYY-MM-DD'),
        viewType: this.defaultView,
      }

      // if(viewType == 'dayGridMonth'){
      //   dates.startDate = moment(this.formDate.startDate).startOf('month').format('YYYY-MM-DD')
      //   dates.endDate = moment(this.formDate.startDate).endOf('month').format('YYYY-MM-DD')
      // }
      // if(viewType == 'dayGridWeek'){
      //   dates.startDate = moment(this.formDate.startDate).startOf('week').format('YYYY-MM-DD')
      //   dates.endDate = moment(this.formDate.startDate).endOf('week').format('YYYY-MM-DD')
      // }
      // if(viewType == 'timeGridDay'){
      //   dates.startDate = moment(this.formDate.startDate).format('YYYY-MM-DD')
      //   dates.endDate = moment(this.formDate.startDate).format('YYYY-MM-DD')
      // }

      this.calendarApi().changeView(viewType)
      this.$emit('calendarDateChanged', dates)
    },

    next() {
      var dates = {
        startDate: this.formDate.startDate,
        endDate: this.formDate.endDate,
        viewType: this.defaultView,
      }

      if (this.defaultView == 'dayGridMonth') {
        dates.startDate = moment(this.formDate.startDate)
          .add(1, 'month')
          .startOf('month')
          .format('YYYY-MM-DD')
        dates.endDate = moment(this.formDate.startDate)
          .add(1, 'month')
          .endOf('month')
          .format('YYYY-MM-DD')
      }

      if (this.defaultView == 'dayGridWeek') {
        dates.startDate = moment(this.formDate.startDate)
          .add(1, 'week')
          .format('YYYY-MM-DD')
        dates.endDate = moment(this.formDate.endDate)
          .add(1, 'week')
          .format('YYYY-MM-DD')
      }

      if (this.defaultView == 'timeGridDay') {
        dates.startDate = moment(this.formDate.startDate)
          .add(1, 'day')
          .format('YYYY-MM-DD')
        dates.endDate = moment(this.formDate.startDate).format('YYYY-MM-DD')
      }

      this.$emit('calendarDateChanged', dates)
      this.calendarApi().next()
    },

    prev() {
      var dates = {
        startDate: this.formDate.startDate,
        endDate: this.formDate.endDate,
        viewType: this.defaultView,
      }

      if (this.defaultView == 'dayGridMonth') {
        dates.startDate = moment(this.formDate.startDate)
          .subtract(1, 'month')
          .startOf('month')
          .format('YYYY-MM-DD')
        dates.endDate = moment(this.formDate.endDate)
          .subtract(1, 'month')
          .endOf('month')
          .format('YYYY-MM-DD')
      }

      if (this.defaultView == 'dayGridWeek') {
        dates.startDate = moment(this.formDate.startDate)
          .subtract(1, 'week')
          .format('YYYY-MM-DD')
        dates.endDate = moment(this.formDate.endDate)
          .subtract(1, 'week')
          .format('YYYY-MM-DD')
      }

      if (this.defaultView == 'timeGridDay') {
        dates.startDate = moment(this.formDate.startDate)
          .subtract(1, 'day')
          .format('YYYY-MM-DD')
        dates.endDate = moment(dates.startDate).format('YYYY-MM-DD')
      }

      this.$emit('calendarDateChanged', dates)
      this.calendarApi().prev()
    },

    nextDayPanel() {
      var selectedDate = moment(this.clickedDate['selectedDate']).format(
        'YYYY-MM-DD'
      )

      //check if the current day of selected date is the last in the month of selected date
      if (
        moment(selectedDate).date() ==
        moment(selectedDate).endOf('month').date()
      ) {
        const firstDayNextMonth = moment(selectedDate)
          .add(1, 'month')
          .startOf('month')
        this.fetchOperations(firstDayNextMonth)
      } else {
        //not yet
        const nextDay = moment(selectedDate).add(1, 'day')
        this.fetchOperations(nextDay)
      }
    },

    prevDayPanel() {
      var selectedDate = moment(this.clickedDate['selectedDate'])

      //check if the current day of selected date is the last in the month of selected date
      if (
        moment(selectedDate).date() ==
        moment(selectedDate).endOf('month').date()
      ) {
        const previousDayLastMinute = selectedDate
          .clone()
          .subtract(1, 'day')
          .endOf('day')
        this.fetchOperations(previousDayLastMinute)
      } else {
        //not yet
        const previousDay = selectedDate.subtract(1, 'day')
        this.fetchOperations(previousDay)
      }
    },

    resolveClickedDate(info) {
      if (!info) return null

      if (info.date) return info.date
      if (info.dateStr) return info.dateStr

      if (info.event) {
        if (info.event.start) return info.event.start
        if (info.event.startStr) return info.event.startStr
      }

      const dayEl =
        (info.dayEl && info.dayEl.getAttribute && info.dayEl) ||
        (info.el && info.el.closest && info.el.closest('[data-date]'))

      if (dayEl) {
        const dataDate = dayEl.getAttribute('data-date')
        if (dataDate) return dataDate
      }

      return null
    },

    onDateClick(info) {
      let date = null
      if (info.el === false) {
        date = info.date
      } else {
        date = this.resolveClickedDate(info)
        if (!date) return
      }

      this.fetchOperations(date)
    },

    fetchOperations(date) {
      //DATE OBJECT TO yyyy-mm-dd
      var formattedDate = moment(date).format('YYYY-MM-DD')

      //Filtering events where date equals {{date}}, the selected day
      var eventosDoDia = this.eventsCalendar.filter(function (val, idx) {
        const dt = moment(val.start).format('YYYY-MM-DD')
        if (dt == formattedDate) {
          return val
        }
      })

      //GROUPING OPERATIONS BY POI NAME
      var grouppedEventsByProduct = this.groupBy(
        eventosDoDia,
        (el) => el.poi.product_name
      )
      grouppedEventsByProduct = Array.from(grouppedEventsByProduct)

      //RETRIEVING POI NAME OF AGROUPED OPERATIONS
      this.clickedDate = grouppedEventsByProduct.map(function (val, idx) {
        val[1].poi = val[1][0].poi
        return val[1]
      })

      this.clickedDate['selectedDate'] = formattedDate
      this.showDateClickedPanel = true
    },

    closeDateClickedModal() {
      this.showDateClickedPanel = false
      this.clickedDate = []
    },

    showRowDetail(rowItem) {
      this.selectedReserva = rowItem
      this.showDetail = true
    },

    //METHOD TO GROUP BY KEYGETTER.
    //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return map
    },
  },

  mounted() {
    if (
      sessionStorage.getItem('operationViewMode') &&
      sessionStorage.getItem('operationViewMode') != this.defaultView
    ) {
      this.changeView(sessionStorage.getItem('operationViewMode'))
    }
  },
}
</script>

<style lang="scss">
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';
@import '~@/assets/sass/core/vendors/fullcalendar';

.bg-pick {
  background-color: white;
  height: 25px;
  width: fit-content;
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 4px;
}

.fc-unthemed td.fc-today {
  background-color: white;
}

.fc-day-number {
  font-weight: normal;
  font-size: 13px;
  margin-right: 10px;
}
.fc-day-top {
  height: 30px;
}

.fc-today {
  font-weight: 600;
  .fc-day-number {
    background-color: #a7aa37;
    color: white;
    width: 22px;
    height: 20px;
    border-top: 4px solid #fff;
    font-weight: bold;
    border-radius: 50%;
    display: flex;
    justify-content: center;
  }
}

.fc-dayGrid-view .fc-body .fc-row {
  max-height: 120px;
}

.fc-day {
  background-color: white;
}

.fc-other-month {
  background-color: transparent;
}

.fc-event.fc-h-event {
  height: 20px !important;
  font-size: 12px !important;
}

.fc-event.fc-h-event .bc-booking-code,
.fc-event.fc-h-event .bc-client-name {
  font-size: 11px !important;
}

.fc-event-container {
  cursor: default;
}
.fc-event.fc-h-event .fc-content span {
  position: relative;
  display: inline-block;
  overflow: hidden;
}

.booking-list-period-label {
  cursor: pointer;
  user-select: none;
  font-size: 0.9rem;
}

.booking-list-period-label span:hover {
  text-decoration: underline;
}

.show-quotes-toggle {
  cursor: pointer;
  user-select: none;
  color: #12576e;
}

.show-quotes-toggle h4 {
  color: inherit;
  font-weight: 500;
}

.fc-day-grid-event.fc-h-event .fc-content,
.fc-time-grid-event .fc-content {
  overflow: hidden;
}

.fc-day-grid-event.fc-h-event .fc-content .fc-title,
.fc-time-grid-event .fc-title {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.25;
}

a.fc-more.bc-day-totals {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 12px;
  color: #12576e;
  white-space: nowrap;
}

a.fc-more.bc-day-totals i {
  font-size: 11px;
}

a.fc-more.bc-day-totals .bc-day-totals-sep {
  font-weight: 400;
  opacity: 0.55;
}

.booking-list-hidden-datepicker {
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  opacity: 0 !important;
  overflow: hidden !important;
  pointer-events: none !important;
}

.booking-list-hidden-datepicker .el-input__inner {
  padding: 0 !important;
  height: 0 !important;
  line-height: 0 !important;
  border: none !important;
}

.booking-list-view-select {
  max-width: 140px;
  margin-left: auto;
}

.w-100 .container-fluid {
  width: 100%;
  padding: 0 !important;
}
</style>
